import axios from 'axios';

const api = axios.create({
  baseURL: '/', // 替换为实际后端 URL
  timeout: 100000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    // 对于Google登录接口，即使返回401，也要检查响应数据是否包含成功信息
    if (error.response && error.config?.url?.includes('google_login_controller')) {
      const responseData = error.response.data;
      // 如果响应数据表明成功（包含用户信息），则返回数据而不是错误
      if (responseData && (responseData.success === true || responseData.user || responseData.data || responseData.code === 100)) {
        console.log('Google登录API返回401但包含成功数据，继续处理:', responseData);
        return responseData;
      }
    }
    
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default api;

